<div class="rating-block">
  @if (visit_info_loaded && comments_loaded && !is_submitted && !is_guest) {
    <div class="text">{{ 'game-review.review-title' | customLocale }}
    </div>
    <div class="thumbs-block">
      <div class="item" (click)="like()">
        <svg class="icon icon--like" [class.active]="visit_info && visit_info.is_liked">
          <use [attr.xlink:href]="svgSetIcon('thumb-up')"></use>
        </svg>
        <span class="value" [class.value--color--pink]="visit_info && visit_info.is_liked">
          {{stats.likes_count}}
        </span>
      </div>
      <div class="item" (click)="dislike()">
        <svg class="icon icon--dislike" [class.active]="visit_info && visit_info.is_disliked">
          <use [attr.xlink:href]="svgSetIcon('thumb-down')"></use>
        </svg>
        <span class="value" [class.value--color--pink]="visit_info && visit_info.is_disliked">
          {{stats.dislikes_count}}
        </span>
      </div>
    </div>
    @if (comments_loaded && !is_commented) {
      <label class="input-block">
        <textarea
          class="comment"
          [disabled]="submitting"
          [style.height.px]="commentHeight"
          rows="1"
          [(ngModel)]="comment"
          (keyup)="onCommentChange()"
        placeholder="{{ 'game-review.comment-placeholder' | customLocale }}"></textarea>
        <svg class="submit-button" (click)="submit()">
          <use [attr.xlink:href]="svgSetIcon('submit')"></use>
        </svg>
      </label>
      <div class="repeat-comments">
        <pre class="comment">{{ comment }}!</pre>
      </div>
    }
  }

  @if (submitting) {
    <div class="spinner2"><div class="dot-floating"></div></div>
  }

  @if (is_submitted) {
    <div class="text">{{ 'game-review.success-title' | customLocale }}</div>
  }
</div>
